import ActivityPreviewLink from "PFApp/components/activity_commons/activity_preview_link";
import { ActivityCustomValuesList } from "PFApp/components/custom_values_list";
import { useActivityNameAndId } from "PFCore/helpers/activities";
import { useCustomTypes } from "PFCore/helpers/use_custom_types";
import { Activity, CustomType } from "PFTypes";
import { useTranslation } from "react-i18next";

import css from "./content.module.scss";
import { Description } from "./description";
import { RolePositionFinalDataRow } from "./role_position_final_data_row";

export type RolePositionContentProps = {
  task: Activity;
  isFeed?: boolean;
};

const getLocationsLabel = (metadata: Activity["metadata"]) => {
  const locationItems = Array.isArray(metadata?.location) ? metadata.location : [metadata?.location];
  return locationItems
    .map((item) => `${item?.value || item || ""}`)
    .filter(Boolean)
    .join(", ");
};

const NO_LANGUAGES_INFO = { values: undefined, displayAs: undefined };

const getLanguagesInfo = (task: Activity, customTypes: CustomType[]) => {
  const customField = task.custom_fields.find(({ type }) => type.name === "languages");
  if (!customField || !customField.values.length) {
    return NO_LANGUAGES_INFO;
  }

  const customType = customTypes.find(({ id }) => id === customField.type.id);
  return { values: customField.values, displayAs: customType?.display_as };
};

export const RolePositionContent = ({ task, isFeed }: RolePositionContentProps) => {
  const { t } = useTranslation();
  const skills = task.custom_fields.find((item) => item.type.name === "skills");
  const { customTypes } = useCustomTypes();
  const getRoleNameId = useActivityNameAndId();
  const { name, id } = getRoleNameId(task);

  const { values: languageValues, displayAs: languageDisplayAs } = getLanguagesInfo(task, customTypes || []);
  const locations = getLocationsLabel(task.metadata);

  return (
    <div className={css.wrapper}>
      <ActivityPreviewLink activity={task} profile={task.profile} className={css.fullWidth}>
        <div className={css.header}>
          <h3>{name}</h3>
          {id && <div>{t("id", { id })}</div>}
        </div>
        <div className={css.description}>
          <Description description={task.description} />
        </div>
        {skills && (
          <ActivityCustomValuesList
            customFieldName="skills"
            customValues={skills.values}
            activityId={task.id}
            limit={5}
            maxNameLength={isFeed ? 25 : undefined}
          />
        )}

        <RolePositionFinalDataRow
          locations={locations}
          languageValues={languageValues}
          languageDisplayAs={languageDisplayAs}
        />
      </ActivityPreviewLink>
    </div>
  );
};
